// extracted by mini-css-extract-plugin
export default {"MenuContent":"📚19-10-2nN_h_","MenuSelectControl":"📚19-10-2l7zWZ"};